const calendarServiceCard = {
  schedule: 'Schedule',
  scheduledDate: 'Scheduled Date',
  scheduledTo: 'Scheduled For',
  scheduled: 'Scheduled',
};

export default calendarServiceCard;
